var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [
            _vm._v(
              "\n        Liquidación de ventas\n        " +
                _vm._s(
                  _vm.numero_documento !== ""
                    ? _vm.tipo_documento + "-" + _vm.numero_documento
                    : ""
                ) +
                "\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.consultaRealizada,
                    expression: "!consultaRealizada"
                  }
                ],
                staticClass: "btn-info btn--bigger",
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.numero_documento == "" || _vm.id !== "",
                    expression: "numero_documento == '' || id !== ''"
                  }
                ],
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.liquidar }
              },
              [
                _c("i", { staticClass: "fa fa-check" }),
                _c("span", [_vm._v("Liquidar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.numero_documento != "",
                    expression: "numero_documento != ''"
                  }
                ],
                staticClass: "btn-danger",
                attrs: { type: "button" },
                on: { click: _vm.imprimirPdf }
              },
              [
                _c("i", { staticClass: "fa fa-file-pdf-o" }),
                _c("span", [_vm._v("PDF")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.numero_documento != "",
                    expression: "numero_documento != ''"
                  }
                ],
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.imprimirExcel }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Excel")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.nuevaLiquidacion }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _c("span", [_vm._v("Nueva liquidación")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.numero_documento != "",
                    expression: "numero_documento != ''"
                  }
                ],
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.generarHistorial }
              },
              [
                _c("i", { staticClass: "fa fa-table" }),
                _c("span", [_vm._v("Historial de Ventas")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass: "form-field select2 select2-field--stretch",
                  class: {
                    "select2--disabled": _vm.consultaRealizada
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          filterable: false,
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          options: _vm.bodegas,
                          id: "bodegas"
                        },
                        on: { input: _vm.inputBodega },
                        model: {
                          value: _vm.selectedBodega,
                          callback: function($$v) {
                            _vm.selectedBodega = $$v
                          },
                          expression: "selectedBodega"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "bodegas" } }, [
                        _vm._v("Sucursal")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "fecha_liquidacion",
                        locale: "es",
                        "no-label": "",
                        disabled: _vm.consultaRealizada,
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD HH:mm",
                        formatted: "YYYY-MM-DD HH:mm",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.fecha_liquidacion,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha_liquidacion", $$v)
                        },
                        expression: "form.fecha_liquidacion"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Fecha de liquidación")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass: "form-field select2",
                  class: {
                    "select2--disabled": _vm.consultaRealizada
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.vendedores,
                          placeholder: "Seleccione...",
                          label: "descripcion",
                          id: "vendedor"
                        },
                        on: {
                          search: _vm.searchVendedores,
                          input: _vm.inputSupervisor
                        },
                        model: {
                          value: _vm.selectedSupervisor,
                          callback: function($$v) {
                            _vm.selectedSupervisor = $$v
                          },
                          expression: "selectedSupervisor"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "vendedor" } }, [
                        _vm._v("Vendedor")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "desde_venta",
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        disabled: _vm.consultaRealizada,
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.desde_venta,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "desde_venta", $$v)
                        },
                        expression: "form.desde_venta"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Fecha inicial de corte de venta")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "hasta_venta",
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        disabled: _vm.consultaRealizada,
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.hasta_venta,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "hasta_venta", $$v)
                        },
                        expression: "form.hasta_venta"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Fecha final de corte de venta")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "desde_recaudacion",
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        disabled: _vm.consultaRealizada,
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.desde_recaudacion,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "desde_recaudacion", $$v)
                        },
                        expression: "form.desde_recaudacion"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Fecha inicial de recaudación")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "hasta_recaudacion",
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        disabled: _vm.consultaRealizada,
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.hasta_recaudacion,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "hasta_recaudacion", $$v)
                        },
                        expression: "form.hasta_recaudacion"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Fecha final de recaudación")])
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.consultaRealizada
        ? _c("div", { staticClass: "row mt-2" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-md-6" },
              [
                _c(
                  "tabs",
                  [
                    _c(
                      "tab",
                      { attrs: { name: "Canceladas" } },
                      [
                        _c("ventas-liquidacion", {
                          attrs: {
                            liquidacion_id: _vm.id,
                            id: "C",
                            supervisor_id: _vm.form.supervisor_id,
                            tipoVenta: "C"
                          },
                          on: { mover: _vm.mover, input: _vm.inputCanceladas },
                          model: {
                            value: _vm.form.ventasCanceladas,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "ventasCanceladas", $$v)
                            },
                            expression: "form.ventasCanceladas"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "tab",
                      { attrs: { name: "Devoluciones completas" } },
                      [
                        _c("ventas-liquidacion", {
                          attrs: {
                            liquidacion_id: _vm.id,
                            id: "DC",
                            supervisor_id: _vm.form.supervisor_id,
                            tipoVenta: "DC"
                          },
                          on: {
                            mover: _vm.mover,
                            input: _vm.inputDevolucionesCompletas
                          },
                          model: {
                            value: _vm.form.devolucionesCompletas,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "devolucionesCompletas", $$v)
                            },
                            expression: "form.devolucionesCompletas"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "tab",
                      { attrs: { name: "Devoluciones parciales" } },
                      [
                        _c("ventas-liquidacion", {
                          attrs: {
                            liquidacion_id: _vm.id,
                            id: "DP",
                            supervisor_id: _vm.form.supervisor_id,
                            tipoVenta: "DP"
                          },
                          on: {
                            mover: _vm.mover,
                            input: _vm.inputDevolucionesParciales
                          },
                          model: {
                            value: _vm.form.devolucionesParciales,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "devolucionesParciales", $$v)
                            },
                            expression: "form.devolucionesParciales"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "tab",
                      { attrs: { name: "Retornos" } },
                      [
                        _c("ventas-liquidacion", {
                          attrs: {
                            liquidacion_id: _vm.id,
                            id: "R",
                            supervisor_id: _vm.form.supervisor_id,
                            tipoVenta: "R"
                          },
                          on: { mover: _vm.mover, input: _vm.inputRetornos },
                          model: {
                            value: _vm.form.retornos,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "retornos", $$v)
                            },
                            expression: "form.retornos"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "tab",
                      { attrs: { name: "Incobrables" } },
                      [
                        _c("ventas-liquidacion", {
                          attrs: {
                            liquidacion_id: _vm.id,
                            id: "I",
                            supervisor_id: _vm.form.supervisor_id,
                            tipoVenta: "I"
                          },
                          on: { mover: _vm.mover, input: _vm.inputIncobrables },
                          model: {
                            value: _vm.form.incobrables,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "incobrables", $$v)
                            },
                            expression: "form.incobrables"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card__title" }, [
                  _c("h5", [_vm._v("Movimientos")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card__controls" }, [
                    _c(
                      "div",
                      { staticClass: "form-field" },
                      [
                        _c("input-field", {
                          attrs: {
                            id: "busqueda_movimientos",
                            placeholder: "Realice una búsqueda..."
                          },
                          model: {
                            value: _vm.searchMovimientos,
                            callback: function($$v) {
                              _vm.searchMovimientos = $$v
                            },
                            expression: "searchMovimientos"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "card__content",
                    staticStyle: { "max-height": "300px" }
                  },
                  [
                    _c("div", { staticClass: "table-responsive" }, [
                      _c("table", { staticClass: "custom-table" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Tipo de movimiento")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Fecha")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Día")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Detalle")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Valor")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Saldo")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Valor seleccionado")]),
                            _vm._v(" "),
                            _c("th", [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.consultaRealizada,
                                      expression: "consultaRealizada"
                                    }
                                  ],
                                  staticClass: "btn-success",
                                  attrs: { tooltip: "Agregar venta" },
                                  on: { click: _vm.agregarMovimientos }
                                },
                                [_c("i", { staticClass: "fa fa-plus" })]
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.form.movimientos, function(
                              movimiento,
                              index
                            ) {
                              return _c(
                                "tr",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.coincideMovimientos(
                                        movimiento
                                      ),
                                      expression:
                                        "coincideMovimientos(movimiento)"
                                    }
                                  ],
                                  key: movimiento.id,
                                  class: {
                                    "tr--canceled": movimiento.valor < 0
                                  }
                                },
                                [
                                  _c("td", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          movimiento.descripcion_tipo_movimiento
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(movimiento.fecha) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(movimiento.nombre_dia) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(movimiento.detalle) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.moneyFormat(movimiento.valor)
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.moneyFormat(movimiento.saldo)
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.moneyFormat(movimiento.valor_pago)
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn-danger btn--text",
                                        attrs: { tooltip: "Quitar" },
                                        on: {
                                          click: function($event) {
                                            return _vm.quitarMovimiento(index)
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-times" })]
                                    )
                                  ])
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "tr",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.form.retornos.length > 0,
                                    expression: "form.retornos.length > 0"
                                  }
                                ],
                                staticClass: "tr--canceled"
                              },
                              [
                                _c("td", [
                                  _vm._v(
                                    "\n                    Retornos\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.moneyFormat(_vm.totalRetornado * -1)
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.moneyFormat(_vm.totalRetornado)
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.moneyFormat(_vm.totalRetornado * -1)
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td")
                              ]
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("tfoot", [
                          _c("tr", [
                            _c(
                              "th",
                              { attrs: { colspan: "6", scope: "row" } },
                              [_vm._v("Totales")]
                            ),
                            _vm._v(" "),
                            _c("td", { attrs: { colspan: "2" } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.moneyFormat(_vm.totalMovimientos)
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.consultaRealizada
        ? _c("div", { staticClass: "row mt-2" }, [
            _c("div", { staticClass: "col-xs-12 col-md-8" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "table-responsive",
                      staticStyle: { "max-height": "300px" }
                    },
                    [
                      _c("table", { staticClass: "custom-table" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("tbody", [
                          _c("tr", [
                            _c("td", [
                              _c("div", { staticClass: "table-responsive" }, [
                                _c("table", { staticClass: "custom-table" }, [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c("tbody", [
                                    _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(_vm.form.ventas_nuevas) +
                                            "\n                            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(_vm.form.ventas_pendientes) +
                                            "\n                            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(_vm.form.ventas_totales) +
                                            "\n                            "
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", { staticClass: "table-responsive" }, [
                                _c("table", { staticClass: "custom-table" }, [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _c("tbody", [
                                    _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(_vm.form.canceladas) +
                                            "\n                            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(_vm.form.dev_completa) +
                                            "\n                            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(_vm.form.dev_parcial) +
                                            "\n                            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(_vm.form.retorno) +
                                            "\n                            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(_vm.form.incobrable) +
                                            "\n                            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(_vm.totalPendientes) +
                                            "\n                            "
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", { staticClass: "table-responsive" }, [
                                _c("table", { staticClass: "custom-table" }, [
                                  _vm._m(4),
                                  _vm._v(" "),
                                  _c("tbody", [
                                    _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(
                                              _vm.form.proximas_pendientes
                                            ) +
                                            "\n                            "
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "table-responsive",
                      staticStyle: { "max-height": "300px" }
                    },
                    [
                      _c("table", { staticClass: "custom-table" }, [
                        _vm._m(6),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.form.comisiones, function(comision) {
                              return _c("tr", { key: comision.descripcion }, [
                                _c("td", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(comision.descripcion) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.moneyFormat(comision.comision)
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(comision.cantidad) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.moneyFormat(comision.total)) +
                                      "\n                  "
                                  )
                                ])
                              ])
                            }),
                            _vm._v(" "),
                            _c(
                              "tr",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.form.comisiones.length === 0,
                                    expression: "form.comisiones.length === 0"
                                  }
                                ]
                              },
                              [_vm._m(7)]
                            )
                          ],
                          2
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", { staticClass: "custom-table" }, [
                      _vm._m(8),
                      _vm._v(" "),
                      _c("tbody", [
                        _c("tr", [
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.moneyFormat(_vm.totalComision)) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.moneyFormat(_vm.totalGastos)) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.moneyFormat(_vm.liquidoRecibir)) +
                                "\n                  "
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            name: "tableSelectMov",
            height: "auto",
            width: "70%",
            scrollable: "",
            resizable: "",
            adaptive: "",
            reset: ""
          }
        },
        [
          _c("k-table-select", {
            ref: "kTableSelectMov",
            attrs: {
              columnas: [
                {
                  nombre: "tipo_movimiento.descripcion",
                  descripcion: "Tipo de movimiento"
                },
                {
                  nombre: "fecha",
                  descripcion: "Fecha",
                  sortable: true
                },
                {
                  nombre: "nombre_dia",
                  descripcion: "Día",
                  sortable: true
                },
                {
                  nombre: "detalle",
                  descripcion: "Detalle",
                  sortable: true
                },
                {
                  nombre: "valor",
                  descripcion: "Valor",
                  money: true,
                  sortable: true
                },
                {
                  nombre: "saldo",
                  descripcion: "Saldo",
                  money: true,
                  sortable: true
                },
                {
                  nombre: "valor_pago",
                  descripcion: "Valor seleccionado",
                  money: true,
                  sortable: true
                }
              ],
              saldoSeleccionable: "",
              params: {
                vendedor_id: _vm.form.supervisor_id
              },
              urlConsulta: _vm.url + "/movimientos-nomina-supervisor",
              title: "Seleccione uno o varios movimientos"
            },
            on: {
              cerrar: _vm.cerrarMovimientos,
              seleccionar: _vm.seleccionarMovimientos
            },
            model: {
              value: _vm.form.movimientos,
              callback: function($$v) {
                _vm.$set(_vm.form, "movimientos", $$v)
              },
              expression: "form.movimientos"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Ventas")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Semana Anterior")]),
        _vm._v(" "),
        _c("th", [_vm._v("Liquidación")]),
        _vm._v(" "),
        _c("th", [_vm._v("Próxima Semana")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Nuevas")]),
        _vm._v(" "),
        _c("th", [_vm._v("Pendientes")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Canceladas")]),
        _vm._v(" "),
        _c("th", [_vm._v("Dev. Completa")]),
        _vm._v(" "),
        _c("th", [_vm._v("Dev. Parcial")]),
        _vm._v(" "),
        _c("th", [_vm._v("Retorno")]),
        _vm._v(" "),
        _c("th", [_vm._v("Incobrable")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total/Pendiente")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [_c("tr", [_c("th", [_vm._v("Pendiente")])])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Comisiones")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Detalle")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("strong", [_vm._v("No se ha encontrado comisiones.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Total de comisión")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total de descuentos")]),
        _vm._v(" "),
        _c("th", [_vm._v("Líquido a recibir")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa527cca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa527cca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/LiquidacionVentas.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-aa527cca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/LiquidacionVentas.vue
// module chunks = 0